module.exports = __webpack_public_path__ + "media/i_phone_notification.356f40ab.mp3";